module.exports = __webpack_public_path__ + "img/fenleiguanli_xz.d2717f2e.svg";